export const LOAN_RATE = 4.0;
export const LOAN_RATE_UNDER_30 = 3.5;
export const LOAN_RATE_GREEN_VEHICLE = 3.15;

// AUTO FESTIVAL 23
//export const LOAN_RATE = 3.0;
//export const LOAN_RATE_UNDER_30 = 2.75;
//export const LOAN_RATE_GREEN_VEHICLE = 2.15;